import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronRight, X, ListChecks } from "lucide-react";

export function OnboardingChecklist() {
  const { activeTenantId, role } = useAuth();
  const [items, setItems] = useState(null);
  const [minimized, setMinimized] = useState(false);
  const isConfigurator = role === "admin" || role === "manager";

  useEffect(() => {
    if (!activeTenantId || !isConfigurator) return;
    setMinimized(localStorage.getItem(`onboarding_minimized_${activeTenantId}`) === "1");
    api.get("/onboarding/checklist").then((r) => setItems(r.data.items)).catch(() => {});
  }, [activeTenantId, isConfigurator]);

  if (!isConfigurator || !items) return null;
  const pending = items.filter((i) => !i.done);
  if (pending.length === 0) return null;

  const setMin = (val) => {
    setMinimized(val);
    localStorage.setItem(`onboarding_minimized_${activeTenantId}`, val ? "1" : "0");
  };

  if (minimized) {
    return (
      <button
        onClick={() => setMin(false)}
        data-testid="onboarding-checklist-expand"
        className="text-xs text-[#0055FF] hover:underline flex items-center gap-1.5"
      >
        <ListChecks className="h-3.5 w-3.5" /> Configuración pendiente ({pending.length})
      </button>
    );
  }

  return (
    <Card
      className="rounded-sm border-[#0055FF]/30 bg-[#0055FF]/[0.03] shadow-none p-5"
      data-testid="onboarding-checklist"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading font-bold text-sm text-[#09090B]">Terminá de configurar tu cuenta</h3>
          <p className="text-xs text-[#71717A] mt-0.5">
            {pending.length} de {items.length} pendientes. Podés seguir usando la plataforma mientras tanto.
          </p>
        </div>
        <button
          onClick={() => setMin(true)} data-testid="onboarding-checklist-minimize"
          className="text-[#A1A1AA] hover:text-[#71717A] shrink-0"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-4 space-y-2">
        {pending.map((item) => (
          <div
            key={item.key} data-testid={`onboarding-item-${item.key}`}
            className="flex items-center justify-between gap-3 bg-white rounded-sm border border-[#E4E4E7] px-3 py-2"
          >
            <div>
              <p className="text-sm font-medium text-[#09090B]">{item.label}</p>
              <p className="text-xs text-[#71717A]">{item.why}</p>
            </div>
            <Button
              asChild size="sm" variant="outline" className="rounded-sm shrink-0"
              data-testid={`onboarding-item-${item.key}-button`}
            >
              <Link to={item.link}>Resolver <ChevronRight className="h-3.5 w-3.5 ml-1" /></Link>
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
